export const calculatedSavings = (
  calculatorFormData,
  SavingsAmount,
  isPageLoad
) => {
  const properties = {
    pricePerPack: calculatorFormData.price_per_pack,
    cigarettesDaily: calculatorFormData.cigarettes_per_day,
    SavingsAmount,
  };
  if (isPageLoad) {
    analytics.track('Calculator Stats Returned', properties);
  } else {
    analytics.track('Calculator Stats Saved', properties);
  }
};



// WEBPACK FOOTER //
// ./app/javascript/apps/calculator/tracking.js